import { createContext } from 'react';

import { emptyFn } from '@app/constants';
import type { NIntegrationProvider } from '@app/providers/IntegrationsProvider/IntegrationsProvider.types';

export const IntegrationsContext = createContext<NIntegrationProvider.Context>({
  isWhatsAppModalOpen: false,
  setIsWhatsAppModalOpen: () => {},
  isOAuthFrameOpen: false,
  setIsOAuthFrameOpen: () => {},
  isAtcModalOpen: false,
  setIsAtcModalOpen: () => {},
  isSocialMediaSettingsModalOpen: false,
  setIsSocialMediaSettingsModalOpen: () => {},
  isEmailModalOpen: false,
  setIsEmailModalOpen: () => {},
  setCurrentIntegrationType: () => {},
  currentIntegrationType: '',
  integrations: [],
  setIntegrations: () => {},
  setIsOpenAddWhatsAppIntegrationWarningModal: () => {},
  isOpenAddWhatsAppIntegrationWarningModal: false,
  isYooKassaModalOpen: false,
  setIsYooKassaModalOpen: emptyFn,
  isAdd1CIntegrationModalOpen: false,
  setIsAdd1CIntegrationModalOpen: emptyFn,
  isEdit1CIntegrationModalOpen: false,
  setIsEdit1CIntegrationModalOpen: emptyFn,
  edit1CIntegrationId: null,
  setEdit1CIntegrationId: emptyFn,
  edit1CIntegrationMode: 'edit',
  setEdit1CIntegrationMode: emptyFn,
  currentYooKassaIntegrationId: null,
  setCurrentYooKassaIntegrationId: emptyFn,
  isExportLogVisible: false,
  setIsExportLogVisible: emptyFn,
});
